import { Form } from "components";
import { PinInput } from "./native";

export default function Pin(props){
    return(
    <Form.Field {...props}>
        <PinInput {...props} />
    </Form.Field>
    )
}